<template>
  <q-dialog
    v-model="shown"
    persistent
    maximized
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <q-card
      class="bg-dark text-white"
      :class="[$q.screen.lt.lg || isPhonePreview ? '' : 'q-mx-xxl q-my-xs']"
      :style="$q.screen.lt.md || isPhonePreview ? '' : 'height: auto;'"
    >
      <q-bar>
        <q-space />

        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-bar>
      <q-resize-observer
        debounce="500"
        @resize="setVideoStyle"
      />
      <q-video
        v-if="!!videoUrlComputedProperty"
        :style="{ 'top': $q.screen.lt.md ? '20%' : '' }"
        :ratio="16/9"
        :src="videoUrlComputedProperty"
      />
    </q-card>
  </q-dialog>
</template>

<script>

const VIEWPORT_RATIO_16_BY_9_AS_PERCENTAGE = (9 / 16) * 100
export default {
  name: 'TrailerPlayerDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    trailerYoutubeId: {
      type: String,
      required: false,
      default: null
    },
    trailerVimeoId: {
      type: String,
      required: false,
      default: null
    },
    isPhonePreview: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      videoStyle: ''
    }
  },
  computed: {
    videoUrlComputedProperty () {
      if (this.trailerVimeoId) {
        return `https://player.vimeo.com/video/${this.trailerVimeoId}`
      } else if (this.trailerYoutubeId) {
        return `https://www.youtube.com/embed/${this.trailerYoutubeId}`
      } else {
        return null
      }
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    setVideoStyle () {
      const ratio = ((window.innerHeight / window.innerWidth) * 100).toFixed(2)
      this.videoStyle = ratio < VIEWPORT_RATIO_16_BY_9_AS_PERCENTAGE ? `padding-bottom: ${ratio}%` : ''
    }
  }
}
</script>
